import React from 'react';
import RankingsAndLevelsComponent from "../../components/RankingsAndLevelsComponent/RankingsAndLevelsComponent";
// @ts-ignore
import {Route, Switch} from 'react-router-dom';
import HomeComponent from "../home/HomeComponent";
import MapContainer from "../../components/RankingsAndLevelsMap/MapContainer";
import CountryContainer from "../../components/RankingsAndLevelsCountry/CountryContainer";
import Constants from "../../data/Constants";
import CountryGraphicsContainer from "../../components/RankingsAndLevelsCountryGraphics/CountryGraphicsContainer";
import TierContainer from "../../components/RankingsAndLevelsTier/TierContainer";
import TierGraphicsContainer from "../../components/RankingsAndLevelsTierGraphics/TierGraphicsContainer";


const RankingsAndLevels = () => (
    <HomeComponent>
        <Switch>
            <Route exact path={Constants.routes.rankings} component={HomeRanking}/>
            <Route exact path={Constants.routes.rankingsMap} component={RankingAndLevelsMap}/>
            <Route exact path={Constants.routes.rankingsCountry} component={RankingAndLevelsCountry}/>
            <Route exact path={Constants.routes.rankingsCountryGraphics}
                   component={RankingAndLevelsCountryGraphics}/>
            <Route exact path={Constants.routes.rankingsTiers} component={RankingAndLevelsTier}/>
            <Route exact path={Constants.routes.rankingsTierGraphics} component={RankingAndLevelsTierGraphics}/>
        </Switch>
    </HomeComponent>
);

export default RankingsAndLevels;

export const HomeRanking: React.FC = () => {
    return (
        <RankingsAndLevelsComponent/>
    )
};

export const RankingAndLevelsMap: React.FC = () => {
    return (
        <MapContainer/>
    )
};

export const RankingAndLevelsCountry: React.FC = () => {
    return (
        <CountryContainer/>
    )
};

export const RankingAndLevelsCountryGraphics: React.FC = () => {
    return (
        <CountryGraphicsContainer/>
    )
};

export const RankingAndLevelsTier: React.FC = () => {
    return (
        <TierContainer/>
    )
};

export const RankingAndLevelsTierGraphics: React.FC = () => {
    return (
        <TierGraphicsContainer/>
    )
};
